import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import DataTable from '../../../../shared/components/DataTable';
import StudentSubjectFilterForm from './FilterForm';
import {
  reporteAlumnosFormData,
} from '../../../../redux/actions/studentsActions';
import {
  fetchFormDatas,
} from '../../../../redux/actions/contentRecordsActions';
import {
  reporteRegistroContenidoProfesores,
  descargarReporteRegistroContenidoProfesores,
} from '../../../../redux/actions/professorActions';
import { createErrorMessage } from '../../../../helpers/notification';
import { dateDDMMYYFormat } from '../../../../helpers/dateFormat';

class StudentsContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.handleOnFilterChange = this.handleOnFilterChange.bind(this);
    this.descargarReporteRegistroContenidoProfesores.bind(this);
    this.state = {
      page: 1,
      pageSize: 100,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: { id: 0 },
      tipoContenido: [],
      tipoClase: [],
      tipoModalidad: [],
      metodologias: [],
    };

    this.columns = (
      tipoContenido = [],
      tipoClase = [],
      tipoModalidad = [],
      metodologias = [],
    ) => [
      { key: 'numDoc', name: 'C.I. Nº', width: '120px' },
      { key: 'lastName', name: 'Apellido', width: '15%' },
      { key: 'name', name: 'Nombre', width: '15%' },
      { key: 'periodo', name: 'Periodo', width: '15%' },
      { key: 'carrera', name: 'Carrera' },
      { key: 'malla', name: 'Malla' },
      {
        key: 'Semestre',
        name: 'Semestre',
        format: row => `${row.semestre}º`,
      },
      { key: 'materiaPeriodo', name: 'Materia' },
      {
        key: 'fecha',
        className: 'text-center',
        name: 'Fecha',
        width: '130px',
        format: row => dateDDMMYYFormat(row.fecha),
      },
      {
        key: 'tipoClase',
        name: 'TipoClase',
        format: (row) => {
          const tipo = tipoClase.find(tc => tc.value === row.tipoClase);
          if (tipo) {
            return tipo.label;
          }

          return '';
        },
      },
      {
        key: 'modalidad',
        name: 'Modalidad',
        format: (row) => {
          const modalidad = tipoModalidad.find(tc => tc.value === row.modalidad);
          if (modalidad) {
            return modalidad.label;
          }

          return '';
        },
      },
      { key: 'contenidos', name: 'Contenidos' },
      {
        key: 'metodologias',
        name: 'Metodologias',
        format: (row) => {
          const valores = Array.isArray(row.metodologias)
            ? row.metodologias.map(m => m.value)
            : [];

          return metodologias
            .filter(tc => valores.includes(tc.value))
            .map(tc => tc.label)
            .join(', ');
        },
      },
      {
        key: 'tiposContenidos',
        name: 'TiposContenidos',
        format: row => tipoContenido
          .filter(tc => row.tiposContenidos.includes(tc.value))
          .map(tc => tc.label)
          .join(', '),
      },
      { key: 'unidad', name: 'Unidad' },
    ];
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.fetchFormData(page, pageSize);
  }

  fetchFormData = () => {
    reporteAlumnosFormData({
      onSuccess: (formData) => {
        const { materias } = formData;
        const distinctMaterias = materias.filter((v, index, self) => self.map(x => x.label).indexOf(v.label) === index);
        fetchFormDatas({
          onSuccess: ({
            tipoContenido,
            tipoClase,
            tipoModalidad,
            metodologias,
          }) => {
            this.setState({
              ...formData,
              todasLasMaterias: materias,
              materias: distinctMaterias,
              tipoContenido,
              tipoClase,
              tipoModalidad,
              metodologias,
            });
          },
          onError: () => {
            this.setState({ items: [], loading: false });
            createErrorMessage('Error al intentar cargar los datos del formulario');
          },
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar los datos del formulario');
      },
    });
  }

  updateStudentsTable = (page, pageSize, filters) => {
    this.setState({
      loading: true,
      page,
      pageSize,
      filters: filters || {},
    });
    reporteRegistroContenidoProfesores({
      pageInfo: {
        page,
        pageSize,
        filters: filters || {},
      },
      onSuccess: (pageInfo) => {
        this.setState({
          loading: false,
          items: pageInfo.items,
          totalItemsCount: pageInfo.totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de alumnos');
      },
    });
  }

  handleOnFilterChange = (objectKey, idKey, value) => {
    if (objectKey === 'periodo' || objectKey === 'carrera') {
      const { carreraId, periodoId, todasLasMaterias } = this.state;
      let materias = todasLasMaterias.filter(m => (!carreraId || m.carreraId === carreraId)
        && (!periodoId || m.periodoId === periodoId));

      // Filter distinct and use MateriaId
      materias = materias.filter((v, index, self) => self.map(x => x.label).indexOf(v.label) === index)
        .map(x => ({ label: x.label, value: x.materiaId }));
      this.setState({
        [idKey]: value.value,
        [objectKey]: value,
        materias,
      });
    } else {
      this.setState({
        [idKey]: value.value,
        [objectKey]: value,
      });
    }

    const { filters } = this.state;
    filters[idKey] = value.value;

    this.setState({
      filters,
    });
  }

  handleOnFilter = () => {
    const { page, pageSize, filters } = this.state;
    this.updateStudentsTable(page, pageSize, filters);
  }

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateStudentsTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateStudentsTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateStudentsTable(1, pageSize, {});
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  descargarReporteRegistroContenidoProfesores = () => {
    const { filters } = this.state;
    descargarReporteRegistroContenidoProfesores({
      filters: filters || {},
      onError: () => {
        createErrorMessage('Error al intentar descargar la lista de alumnos');
      },
    });
  }

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
      tipoContenido = [],
      tipoClase = [],
      tipoModalidad = [],
      metodologias = [],
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Reporte de registro de contenido de profesores</h3>
          </Col>
        </Row>
        <Row>
          <StudentSubjectFilterForm
            {...this.state}
            onFilterChanges={this.handleOnFilterChange}
            onFilter={this.handleOnFilter}
          />
        </Row>
        <Row>
          <Col md={12} className="text-right">
            {items.length && (
              <button
                className="btn btn-link"
                type="button"
                onClick={this.descargarReporteRegistroContenidoProfesores}
              >
                <span className="fa fa-cloud-download">&nbsp;</span>
                Descargar lista
              </button>
            )}
          </Col>
        </Row>
        <Row>
          {loading ? <Col md={12}><h3 className="page-subhead subhead">Esperando su b&uacute;squeda...</h3></Col>
            : (
              <DataTable
                title="Registros de contenido"
                columns={this.columns(
                  tipoContenido,
                  tipoClase,
                  tipoModalidad,
                  metodologias,
                )}
                items={items}
                onChangePage={this.onChangePage}
                page={page}
                pageSize={pageSize}
                totalItemsCount={totalItemsCount}
                onSubmit={this.onDataTableSubmit}
                onClearFilters={this.onDataTableClearFilters}
                initialValues={filters}
                enableReinitialize
              />
            )
          }
        </Row>
      </Container>
    );
  }
}

export default withRouter(StudentsContainer);
